/* eslint-disable no-new */
import './embed_tile_page.scss';
import {
  hubEventLoadDispatch,
  sharedHubEventsInit,
} from '../../../common/hub_events/shared_hub_events';
import bodyTopInit from '../../components/body_top/body_top';
import footerInit from '../../components/footer/footer';
import TileArea from '../../components/tiles/tile_area';

const initEmbedTile = (): void => {
  const container = document.getElementById('main-content');
  if (!container) return;
  const embedTile = container.querySelector('.uf-embed-tile-wrapper') as HTMLElement;
  if (!embedTile) return;
  new TileArea(container).initializeTile(embedTile);
};

const main = (): void => {
  initEmbedTile();
  sharedHubEventsInit();
  bodyTopInit();
  footerInit();
  hubEventLoadDispatch();
};

document.addEventListener('DOMContentLoaded', main);
